import { graphql } from "gatsby";
import React from "react";
import ExtractRichText from "../../../components/molecules/ExtractRichText";
import { Container, Row } from "react-bootstrap";
import "./paraRichTextContentBlock.scss";
import AnchorID from "../../atoms/AnchorID";

export const ParagraphRichTextContentBlock = ({ node }) => {
  return (
    <>
      {/* <AnchorID id={node.field_section_id} /> */}
      <Container
        className="general-container richText-contentBlock"
        id={node.field_section_id}
      >
        <Row>
          {node?.field_component_title && (
            <h2
              data-aos="underlined"
              className="underlined richText-contentBlock__title"
            >
              {node?.field_component_title}
            </h2>
          )}

          {node?.field_component_subtitle && (
            <h3 className="richText-contentBlock__subtitle">
              {node?.field_component_subtitle}
            </h3>
          )}

          {node?.field_body?.value && (
            <ExtractRichText richText={node?.field_body?.value} />
          )}
        </Row>
      </Container>
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphRichTextContentBlock on paragraph__rich_text {
    __typename
    field_body {
      value
    }
    field_section_id
    field_component_subtitle
    field_component_title
  }
`;
